import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourApi = createApi({
  reducerPath: 'labourApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labour'],
  endpoints: (builder) => ({
    findAllLabourDetails: builder.mutation({
      query(body) {
        return {
          url: spotFinder.labourController.findAllLabourDetails,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    findAvailableLabourDetail: builder.mutation({
      query({bookingId, token}) {
        return {
          url: `${spotFinder.labourController.findAvailableLabourDetail}/${bookingId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    findLabourDetailByUserId: builder.mutation({
      query({userId, token}) {
        return {
          url: `${spotFinder.labourController.findLabourDetailByUserId}/${userId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),

    getLabourDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourController.getLabourDetailById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getAllLabourDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourController.getAllLabourDetail}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    saveLabourDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.labourController.updateLabourDetail
            : spotFinder.labourController.saveLabourDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateLabourDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.labourController.updateLabourDetail
            : spotFinder.labourController.saveLabourDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteLabourDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourController.deleteLabourDetailById}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    uploadLabourDocuments: builder.mutation({
      query(body) {
        return {
          url: `/labour/${body.labourId}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});


export const {
  useFindAllLabourDetailsMutation,
  useGetAllLabourDetailMutation,
  useGetLabourDetailByIdMutation,
  useSaveLabourDetailMutation,
  useUpdateLabourDetailMutation,
  useDeleteLabourDetailByIdMutation,
  useUploadLabourDocumentsMutation,
  useFindAvailableLabourDetailMutation,
  useFindLabourDetailByUserIdMutation,
} = labourApi;
